import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const templateFieldType = v.union(
  v.literal("text"),
  v.literal("number"),
  v.literal("date"),
  v.literal("select"),
  v.literal("checkbox"),
  v.literal("textarea"),
  v.literal("password"),
  v.literal("url"),
  v.literal("email"),
  v.literal("phone"),
  v.literal("currency"),
  v.literal("image"),
  v.literal("image_multiple"),
  v.literal("file"),
  v.literal("signature"),
);

export const templateField = v.object({
  key: v.string(),
  label: v.string(),
  type: templateFieldType,
  required: v.boolean(),
  placeholder: v.optional(v.string()),
  options: v.optional(v.array(v.string())),
  defaultValue: v.optional(v.string()),
  order: v.number(),
});

export const templateCategory = v.union(
  v.literal("maintenance"),
  v.literal("installation"),
  v.literal("inspection"),
  v.literal("report"),
  v.literal("checklist"),
  v.literal("credential"),
  v.literal("warranty"),
  v.literal("contract"),
  v.literal("custom"),
);

export const validatorDocumentTemplate = v.object({
  name: v.string(),
  code: v.optional(v.string()),
  description: v.optional(v.string()),
  category: templateCategory,
  icon: v.optional(v.string()),
  content: v.optional(v.string()),
  fields: v.array(templateField),
  isActive: v.boolean(),
  internalControl,
});

export const document_templates = defineTableWithInternalControl(
  validatorDocumentTemplate,
)
  .index("by_category", ["category"])
  .index("by_company_and_category", ["internalControl.companyId", "category"])
  .index("by_active", ["isActive"])
  .index("by_company_and_active", ["internalControl.companyId", "isActive"])
  .searchIndex("search_templates", {
    searchField: "name",
    filterFields: ["internalControl.companyId", "category", "isActive"],
  });
